module.exports = __webpack_public_path__ + "img/search-minus.7d34c88c.svg";